import { render } from "./App.vue?vue&type=template&id=7a0e54ee"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7a0e54ee&lang=scss"

import exportComponent from "/home/ste/vue/lotto/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__